import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import api from './router/api.js'
import store from './store'

createApp(App)
  .use(api)
  .use(store)
  .use(router, App)
  .mount('#app')
